<template>
  <div>
    <div class="text-center" style="padding: 2em 0 1em;">
      <img src="/static/imgs/logo.png"/>
    </div>

    <div id="formBox" class="panel panel-primary page">
      <div class="panel-heading">
        <span class="panel-title">
            <i class="mdi-action-lock-outline"></i> Login
        </span>
      </div>

      <form novalidate class="form-horizontal" @submit.prevent="login">
        <div class="panel-body">
          <div class="form-group">
            <input type="email" v-model="email" class="form-control floating-label"
                   data-hint="Enter your email address." placeholder="Email">
          </div>

          <div class="form-group">
            <input type="password" v-model="password" class="form-control floating-label"
                   data-hint="Enter your password." placeholder="Password">
          </div>

          {{ error }}
        </div> <!-- .panel-body -->

        <div class="panel-footer zztext-right">
          <a class="btn btn-warning" href="" @click.prevent="toggle_reset_request">Forgot Password</a>
          <button type="submit" @click="login" class="btn btn-primary pull-right">Sign in</button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>
  import {mapGetters} from "vuex"

  export default {
    data () {
      return {
        email: "",
        password: "",
        error: "",
      }
    },
    created() {
      if (this.logged_in) {
        this.$router.push({name: "store-list"});
        return;
      }
      // Pre-fill credentials when running the local dev build. These values are
      // injected at build time from a gitignored dev-credentials.json and are
      // never present in production bundles.
      if (process.env.NODE_ENV === "local") {
        this.email = process.env.DEV_EMAIL || "";
        this.password = process.env.DEV_PASSWORD || "";
      }
    },
    computed: mapGetters(["logged_in"]),
    methods: {
      async login () {
        let login = await (await this.$http.post("/api/login/", {
          email: this.email,
          password: this.password,
        })).json();
        this.password = "";
        if (login.success) {
          await this.$store.dispatch("get_user_info");
          this.$router.push({name: "store-list"});
        } else {
          this.error = login.error;
        }
      },
      toggle_reset_request() {
        this.$router.push({name: "reset-request"});
      },
    },
    watch: {
      logged_in (val) {
        if (val) {
          this.$router.push({name: "store-list"});
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// assets/vue/logger/Login.vue?36ef6456